import {validatenull} from './validate'
import request from '@/router/axios'
import { v4 as uuidv4 } from 'uuid';

// 表单序列化
export const serialize = data => {
  let list = []
  Object.keys(data).forEach(ele => {
    list.push(`${ele}=${data[ele]}`)
  })
  return list.join('&')
}
export const getObjType = obj => {
  var toString = Object.prototype.toString
  var map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  }
  if (obj instanceof Element) {
    return 'element'
  }
  return map[toString.call(obj)]
}
/**
 * 对象深拷贝
 */
export const deepClone = data => {
  var type = getObjType(data)
  var obj
  if (type === 'array') {
    obj = []
  } else if (type === 'object') {
    obj = {}
  } else {
    // 不再具有下一层次
    return data
  }
  if (type === 'array') {
    for (var i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]))
    }
  } else if (type === 'object') {
    for (var key in data) {
      obj[key] = deepClone(data[key])
    }
  }
  return obj
}
/**
 * 判断路由是否相等
 */
export const diff = (obj1, obj2) => {
  delete obj1.close
  var o1 = obj1 instanceof Object
  var o2 = obj2 instanceof Object
  if (!o1 || !o2) { /*  判断不是对象  */
    return obj1 === obj2
  }

  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false
    // Object.keys() 返回一个由对象的自身可枚举属性(key值)组成的数组,例如：数组返回下表：let arr = ["a", "b", "c"];console.log(Object.keys(arr))->0,1,2;
  }

  for (var attr in obj1) {
    var t1 = obj1[attr] instanceof Object
    var t2 = obj2[attr] instanceof Object
    if (t1 && t2) {
      return diff(obj1[attr], obj2[attr])
    } else if (obj1[attr] !== obj2[attr]) {
      return false
    }
  }
  return true
}
/**
 * 设置灰度模式
 */
export const toggleGrayMode = (status) => {
  if (status) {
    document.body.className = document.body.className + ' grayMode'
  } else {
    document.body.className = document.body.className.replace(' grayMode', '')
  }
}
/**
 * 设置主题
 */
export const setTheme = (name) => {
  document.body.className = name
}

/**
 *加密处理
 */
export const encryption = (params) => {
  let {
    data,
    type,
    param,
    key
  } = params
  const result = JSON.parse(JSON.stringify(data))
  if (type === 'Base64') {
    param.forEach(ele => {
      result[ele] = btoa(result[ele])
    })
  } else {
    param.forEach(ele => {
      var data = result[ele]
      key = CryptoJS.enc.Latin1.parse(key)
      var iv = key
      // 加密
      var encrypted = CryptoJS.AES.encrypt(
        data,
        key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.ZeroPadding
        })
      result[ele] = encrypted.toString()
    })
  }
  return result
}

export const md5 = (params) => {
  return CryptoJS.MD5(params).toString()
}

export const OSS_POST = 'image/post/'

export const getFileKey = (file, callback, parentPath) => {
  // 获取文件类型
  let tempList = file.type.split('/')
  let fileType = '.' + tempList[tempList.length - 1]

  // 获取文件md5
  let r = new FileReader()
  r.onloadend = () => {
    let array = new Uint8Array(r.result)
    let result = ''
    let chunk = 8 * 1024
    let i = 0;
    for (i = 0; i < array.length / chunk; i++) {
      result += String.fromCharCode.apply(null, array.slice(i * chunk, (i + 1) * chunk))
    }
    result += String.fromCharCode.apply(null, array.slice(i * chunk))

    // 拼接成文件路径，并传递给回调函数

    let fileKey = (parentPath || OSS_POST) + md5(result) + fileType

    callback(fileKey)
  }
  r.readAsArrayBuffer(file)
}

export async function getFileKeyAsync(file, parentPath) {
  return new Promise((resolve, reject) => {
    getFileKey(file, (fileKey) => {
      resolve(fileKey);
    }, parentPath);
  });
}

/**
 * 浏览器判断是否全屏
 */
export const fullscreenToggel = () => {
  if (fullscreenEnable()) {
    exitFullScreen();
  } else {
    reqFullScreen();
  }
};
/**
 * esc监听全屏
 */
export const listenfullscreen = (callback) => {
  function listen() {
    callback()
  }
  document.addEventListener("fullscreenchange", function () {
    listen();
  });
  document.addEventListener("mozfullscreenchange", function () {
    listen();
  });
  document.addEventListener("webkitfullscreenchange", function () {
    listen();
  });
  document.addEventListener("msfullscreenchange", function () {
    listen();
  });
};
/**
 * 浏览器判断是否全屏
 */
export const fullscreenEnable = () => {
  return document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen
}

/**
 * 浏览器全屏
 */
export const reqFullScreen = () => {
  if (document.documentElement.requestFullScreen) {
    document.documentElement.requestFullScreen();
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.documentElement.webkitRequestFullScreen();
  } else if (document.documentElement.mozRequestFullScreen) {
    document.documentElement.mozRequestFullScreen();
  }
};
/**
 * 浏览器退出全屏
 */
export const exitFullScreen = () => {
  if (document.documentElement.requestFullScreen) {
    document.exitFullScreen();
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.webkitCancelFullScreen();
  } else if (document.documentElement.mozRequestFullScreen) {
    document.mozCancelFullScreen();
  }
};
/**
 * 递归寻找子类的父类
 */

export const findParent = (menu, id) => {
  for (let i = 0; i < menu.length; i++) {
    if (menu[i].children.length != 0) {
      for (let j = 0; j < menu[i].children.length; j++) {
        if (menu[i].children[j].id == id) {
          return menu[i]
        } else {
          if (menu[i].children[j].children.length != 0) {
            return findParent(menu[i].children[j].children, id)
          }
        }
      }
    }
  }
}

/**
 * 动态插入css
 */

export const loadStyle = url => {
  const link = document.createElement('link')
  link.type = 'text/css'
  link.rel = 'stylesheet'
  link.href = url
  const head = document.getElementsByTagName('head')[0]
  head.appendChild(link)
}
/**
 * 判断路由是否相等
 */
export const isObjectValueEqual = (a, b) => {
  let result = true
  Object.keys(a).forEach(ele => {
    const type = typeof (a[ele])
    if (type === 'string' && a[ele] !== b[ele]) result = false
    else if (type === 'object' && JSON.stringify(a[ele]) !== JSON.stringify(b[ele])) result = false
  })
  return result
}
/**
 * 根据字典的value显示label
 */
export const findByvalue = (dic, value) => {
  let result = ''
  if (validatenull(dic)) return value
  if (typeof (value) === 'string' || typeof (value) === 'number' || typeof (value) === 'boolean') {
    let index = 0
    index = findArray(dic, value)
    if (index != -1) {
      result = dic[index].label
    } else {
      result = value
    }
  } else if (value instanceof Array) {
    result = []
    let index = 0
    value.forEach(ele => {
      index = findArray(dic, ele)
      if (index != -1) {
        result.push(dic[index].label)
      } else {
        result.push(value)
      }
    })
    result = result.toString()
  }
  return result
}
/**
 * 根据字典的value查找对应的index
 */
export const findArray = (dic, value) => {
  for (let i = 0; i < dic.length; i++) {
    if (dic[i].value == value) {
      return i
    }
  }
  return -1
}
/**
 * 生成随机len位数字
 */
export const randomLenNum = (len, date) => {
  let random = ''
  random = Math.ceil(Math.random() * 100000000000000).toString().substr(0, len || 4)
  if (date) random = random + Date.now()
  return random
}


// 匹配腾讯视频vid
export function matchQQVideoVid(source) {
  let resultArr = source.match('^http[s]?://(?:m\.v|v).qq.com/.+\.html\\?vid=([^&]+)&.+');

  if (!resultArr) {
    resultArr = source.match('^http[s]?://(?:m\.v|v).qq.com/.+/(.+)\.html');
    if (!resultArr) {
      return '';
    }
  }
  return resultArr[1];
}

// 验证url 正则表达式
export function matchUrl(url) {
  if (/^(http|https):\/\/.*/i.test(url)) {
    return true;
  }
  return false;
}

export const buildVideoThumbnail = (url) => {
  return url + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast,ar_auto';
};

/**
 * 格式化数字为金额形式，四舍五入保留n位小数（默认2位）
 * 123456.005 => 123,456.01
 */
export function formatAsMoney(data, n) {
  n = n > 0 && n <= 20 ? n : 2;
  data = parseFloat((data + '').replace(/[^\d\.-]/g, ''));
  data = data.toLocaleString('zh', { minimumFractionDigits: n, maximumFractionDigits: n });
  return data;
}

export function imageBase64ToUint8Array(b64Image) {
    const img = atob(b64Image.split(',')[1]);
    const imgBuffer = [];
    let i = 0;
    while (i < img.length) {
        imgBuffer.push(img.charCodeAt(i));
        i += 1;
    }
    return new Uint8Array(imgBuffer);
}

export function getObjectURL (file) { // 转换成blob对象 不要问。
  let url = null;
  if (window.createObjectURL !== undefined) {
    // basic
    url = window.createObjectURL(file);
  } else if (window.URL !== undefined) {
    // mozilla(firefox)
    url = window.URL.createObjectURL(file);
  } else if (window.webkitURL !== undefined) {
    // webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  }
  return url;
}

export async function generatorVideoCoverImage(videoFile) {
  return new Promise((resolve, reject) => {
    let videoElement = document.createElement('video');
    const blob = new Blob([videoFile], { type: videoFile.type.toLowerCase() });
    const videoUrl = getObjectURL(blob);
    videoElement.setAttribute('x-webkit-airplay', '');
    videoElement.setAttribute('webkit-playsinline', '');
    videoElement.setAttribute('x5-playsinline', '');
    videoElement.setAttribute('playsinline', '');
    videoElement.setAttribute('x-webkit-airplay', '');
    videoElement.setAttribute('src', videoUrl);
    videoElement.muted = true;

    videoElement.addEventListener('loadeddata', async () => {
      const canvas = document.createElement('canvas');
      canvas.width = videoElement.videoWidth;
      canvas.height = videoElement.videoHeight;
      canvas.getContext('2d')
        .drawImage(videoElement, 0, 0, canvas.width, canvas.height);
      videoElement.setAttribute('src', null);
      window.URL.revokeObjectURL(videoUrl);
      videoElement = null;

      const b64Image = canvas.toDataURL('image/jpeg', 0.4);
      const u8Image = imageBase64ToUint8Array(b64Image);
      const file = new Blob([u8Image], { type: 'image/jpg' });
      resolve({
        file,
        src: URL.createObjectURL(file),
      });
    }, { once: true });

    if (typeof WeixinJSBridge === 'object') {
      window.WeixinJSBridge.invoke('getNetworkType', {}, (e) => {
        videoElement.load();
        videoElement.play();
      });
    } else {
      videoElement.load();
      videoElement.play();
    }
  });
}

export function getOSSPostPath() {
  return 'image/post/';
}

export async function requestWrapper(fn, ...params) {
  try {
    let response = null
    if (typeof params !== 'undefined') {
      response = await fn(...params);
    } else {
      response = await fn();
    }

    if (typeof (response.data) !== 'object') {
      response.data = {
        data: response.data,
      };
    }
    response.data.ok = true;
    return response.data;
  } catch (error) {
    if (error.status && Number(error.status) === 401) {
      throw error;
    }
    return {
      ok: false,
      message: error.message,
    };
  }
}

export function getUUid() {
  return uuidv4();
}

export function isURL(url) {
  return new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i').test(url);
}

export function parseURL(url) {
  const hyperlink = document.createElement('a');
  hyperlink.href = url;
  return {
    source: url,
    protocol: hyperlink.protocol.replace(':', ''),
    host: hyperlink.host,
    hostName: hyperlink.hostname,
    port: hyperlink.port,
    path: hyperlink.pathname.replace(/^([^\/])/, '/$1'),
    query: hyperlink.search,
    params: (() => {
      const params = {};
      const arr = hyperlink.search.replace(/^\?/, '').split('&');
      const len = arr.length;
      for (let i = 0; i < len; i += 1) {
        if (!arr[i]) { continue; }
        const ar = arr[i].split('=');
        params[ar[0]] = ar[1];
      }
      return params;
    })(),
    hash: hyperlink.hash.replace('#', ''),
  };
}
